const routes = require('next-routes');

module.exports = routes()
  .add('order', '/lakat-megrendelese', 'order')
  .add('faq', '/gyakran-ismetelt-kerdesek', 'faq')
  .add('order-success', '/sikeres-megrendeles', 'order-success')
  .add('contact', '/kapcsolat', 'contact');
